import { ConfigSectionEditModel } from './models/config-section-edit.model';
import { SharedTemplateService } from 'src/app/modules/shared/services/template.service';
import { Component, OnInit, Input, OnDestroy, OnChanges, SimpleChanges } from '@angular/core';
import {Section} from './models/section.model';
import { SectionService } from './section.service';
import { CustomService } from '../custom.service';
import { TitleCasePipe } from '@angular/common';
import { AppMainService } from '../../../../app-main.service';
import { SharedChannelService } from '../../../../modules/shared/services/channel.service';
import { PermissionService } from '../../../../service/permission.service';

import { ObjectNames as ChannelObjectNames, Status, FormControl, Severity, Answer } from '../../constants/constants';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { AppMainComponent } from 'src/app/app.main.component';
import { ConfirmationService, MessageService } from 'primeng/api';
import { ObjectNames } from '../../../../shared/constants';
import { ConfigurationService } from 'src/app/configurations/configurationService';
import { AccountModuleId, LeadModuleId } from 'src/app/modules/shared/constants/modules.constant';
import { Subject, takeUntil, Subscription } from 'rxjs';

@Component({
  selector: 'app-crm-custom-section',
  templateUrl: './section.component.html',
  styleUrls: ['./section.component.scss']
})
export class CrmCustomSectionComponent implements OnInit,OnChanges, OnDestroy {

  subscription: Subscription = new Subscription();
  sectionForm: FormGroup;
  allSections : Section[] = [];
  savedSection: Section;
  allModuleNames = [];
  @Input() moduleList = [];
  channelList = [];
  @Input() displaySection: boolean = false;
  selectedModule;
  selectedChannel;
  allTemplates = [];
  selectedTemplate;
  addEditSectionHeader;
  displaySectionAddEdit = false;
  invalidData = false;
  isAddSection: boolean = true;
  displaySectionAvailability: boolean = false;
  caseTemplatesConfig = null;
  userPermissions: any[] = [];

  // Subject to unsubscribe
  private ngUnsubscribe = new Subject<void>();

  constructor(private sectionService: SectionService, private customService: CustomService,
    private fb: FormBuilder, private app: AppMainComponent, private titlecasePipe: TitleCasePipe,
    private messageService: MessageService, private permissionService: PermissionService,
    private configurationService: ConfigurationService, private appMainService: AppMainService,
    private sharedChannelService :SharedChannelService) { }

  ngOnInit(): void {
    this.userPermissions = this.permissionService.getPemrissionData();
    this.sectionForm = this.fb.group({
      id: [0],
      labelName: ['', [Validators.required,Validators.pattern(/^(?!\s*$).+/)]],
      moduleId: [0],
      templateId: [0]
    });
  }


  ngOnChanges(changes: SimpleChanges): void {
    if (changes?.displaySection?.currentValue) {
       this.getModules();
    }
  }

  getModules() {
    this.allModuleNames = this.moduleList?.filter(obj => ( [AccountModuleId,LeadModuleId].includes(obj.id)));
            const permittedModuleIds = this.userPermissions
            .filter(p =>
              p.permissions.some(permission => permission.statusId === 1)
            )
            .map(p => p.objectName);
          const filteredModuleNamesNo = this.allModuleNames.filter(module =>
            permittedModuleIds.includes(module.name)
          );
    this.allModuleNames= filteredModuleNamesNo;
    this.selectedModule = this.allModuleNames[0];
    this.getChannels();
  }

  getChannels(): void {
    this.appMainService.isShowSpinner('getChannel');
    this.sharedChannelService.getChannels(this.selectedModule?.id).pipe(takeUntil(this.ngUnsubscribe)).subscribe({
                next: (response) => {
                    const channels = response || [];
                    this.channelList = this.permissionService.filterChannelsByPermissions(channels, ObjectNames.ACCOUNT);
                    this.selectedChannel = this.channelList?.find(ch=> ch.isDefault);
                    this.appMainService.isHideSpinner('getChannel');
                    this.getModuleSections(this.selectedModule?.id,this.selectedChannel?.id);
                },
                error: (error) => {
                    this.appMainService.isHideSpinner('getChannel');
                    this.messageService.add({
                        severity: 'error',
                        summary: 'Error',
                        detail: error?.error?.message ? error?.error?.message : 'Channels are not loaded, please try again...'
                    });

                },
            });
  }

  selectChannel(){
    this.getModuleSections(this.selectedModule?.id,this.selectedChannel?.id);
  }

  getModuleSections(moduleId: number,channelId: number): void {
    this.sectionService.getModuleSections(moduleId,channelId)
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe(sections => {
        this.allSections = sections;
      });
  }

  showEditSection(section) {
    this.savedSection = section;
    this.isAddSection = false;
    this.sectionForm.patchValue(section);
    this.displaySectionAddEdit = true;
  }

  updateSection(value) {
    if ([AccountModuleId, LeadModuleId].includes(value.moduleId)) {
        const sectionData: ConfigSectionEditModel = {
            moduleId: value.moduleId,
            templateId: value.templateId,
            sectionId: value.id,
            sectionName: value.labelName
        }
        this.appMainService.isShowSpinner('updateSection');
        this.sectionService.updateModuleSections(sectionData).subscribe(response=>{
            this.messageService.add({ severity: Severity.Success, summary: this.titlecasePipe.transform(Severity.Success), detail: 'Section updated successfully...' });
            this.displaySectionAddEdit = false;
            this.getModuleSections(this.selectedModule?.id,this.selectedChannel?.id);
            this.appMainService.isHideSpinner('updateSection');
        },(error)=>{
            this.displaySectionAddEdit = false;
            this.appMainService.isHideSpinner('updateSection');
        })

    }else{
        this.allTemplates.map(template => {
            if (template.templateName == value.templateId.templateName) {
            template.sections.map(section => {
                if (section.id == value.id) {
                section.name = value.name;
                section.isActive = value.isActive,
                    section.templateId = value.templateId.id,
                    section.templateName = value.templateId.templateName,
                    section.updatedBy = this.app.userId;
                section.updatedSource = this.app.userIP;
                section.updatedDate = new Date();
                }
            })
            }
        });
        const templateConfig = {
            ...this.caseTemplatesConfig,
            configJSONValue: JSON.stringify(this.allTemplates)
        };

        this.configurationService.editConfiguration(templateConfig).subscribe(() => {
            this.sectionService.setSection('');
            this.messageService.add({ severity: Severity.Success, summary: this.titlecasePipe.transform(Severity.Success), detail: 'Section updated successfully...' });
           // this.getConfigurationTypes();
            this.displaySectionAddEdit = false;
        },
        err => {
          this.messageService.add({ severity: Severity.Error, summary: this.titlecasePipe.transform(Severity.Error), detail: err.error.Message });
        });
    }
  }

  ngOnDestroy() {
    this.ngUnsubscribe.next();
    this.ngUnsubscribe.complete();
    this.subscription?.unsubscribe();
  }
}
